import axios from 'axios';

class Apii {
    constructor() {}
    allowedMethods = ['get', 'post', 'put', 'delete'];
    baseUrl = '/api';

    setHeaders(headers) {
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('_token');
        for (const key in headers) {
            axios.defaults.headers.common[key] = headers[key];
        }
    }

    prepareMethods(method) {
        let actualMethod = 'post';
        method = method.toLowerCase();
        if (!this.allowedMethods.includes(method)) {
            const error = new Error('Method not allowed.');
            return error;
        }

        switch (method) {
            case 'get':
                actualMethod = 'get';
                break;
            case 'post':
            case 'put':
            case 'delete':
                break;
        }
        return {
            expected: method,
            actual: actualMethod,
        };
    }

    /**
     * Makes calls to the api
     * @param {string} route - The api resource request, users, users/{id}
     * @param {string} method - Http method, get, post, put, delete
     * @param {object} data - Data passed to the resource, { name: 'Bob' }
     * @param {object} headers - Additional headers, { 'Accept', 'application/json' }
     */
    async apiCall(route = '/', method = 'post', data = {}, headers = {}) {
        this.setHeaders(headers);
        const methods = this.prepareMethods(method);
        if (method !== 'post' && method !== 'get') {
            data._method = methods.expected;
        }

        if (methods.actual === 'post' || methods.actual === 'put') {
            return await axios.get('/sanctum/csrf-cookie').then(() => {
                return axios[methods.actual](this.baseUrl + route, data);
            });
        } else {
            if (methods.actual === 'get') {
                data = { params: data };
            }
            const res = await axios[methods.actual](this.baseUrl + route, data);
            return res;
        }
    }
}
export { Apii };
